import { useContext } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Office365GroupContext } from "../../context/Office365GroupContext";
import { useOffice365GroupMembership } from "./useOffice365GroupMembership";

const WSU_RED = "#A60F2D";

const chipSx = {
    backgroundColor: "#fdf0f2",
    border: `1px solid ${WSU_RED}`,
    color: WSU_RED,
    fontWeight: 500,
    fontSize: "0.75rem",
    height: "auto",
    maxWidth: "100%",
    "& .MuiChip-label": {
        display: "block",
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        py: 0.5,
    },
};

const renderMembers = (members) =>
    members?.length > 0 ? (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
            {members.map((member) => (
                <Chip
                    key={member.userPrincipalName}
                    label={member.userPrincipalName}
                    size="small"
                    sx={chipSx}
                />
            ))}
        </Box>
    ) : (
        <Typography variant="body2" color="text.disabled" fontStyle="italic">No members found</Typography>
    );

// Returns a single "Members" tile, sized by the combined length of every
// member's UPN so a large membership list gets a wider tile.
export const useOffice365GroupMembershipSections = () => {
    const { isLoaded, error } = useOffice365GroupMembership();
    const { groupModule } = useContext(Office365GroupContext);

    if (!isLoaded || error) {
        return { isLoaded, error, tiles: [] };
    }

    const members = groupModule.members || [];
    const length = members.map((m) => m.userPrincipalName).join(", ").length;

    const tiles = [{
        key: "Members",
        heading: "Members",
        rows: [{ key: "members", label: "Members", content: renderMembers(members), length }],
        maxLength: length,
    }];

    return { isLoaded, error, tiles };
};
